module.exports = __webpack_public_path__ + "static/media/Hotel-7@2x.bc34ac1c.png";